// import logo from './logo.svg';
import { BrowserRouter, Routes, Route, Outlet, Link } from "react-router-dom";
import SellerSignup from './pages/sellerSignup';
import SellerLogin from "./pages/sellerLogin";
import { useEffect, useState } from "react";
// import { Try } from "./pages/try";
import Information from "./pages/information";
import Dashboard from "./pages/sellerDashboard";
import Upload from "./pages/upload";
import ReturnDB from "./pages/sellerReturnDB";
import OrderRequest from "./pages/orderRequest";
import OnTransitDB from "./pages/onTransit";
import ManageProd from "./pages/manageProd";
import Update from "./pages/update";
import style from './pages/cssModules/index.module.css';
import logo from './pages/gallary/logo1.png';
import styles from './pages/cssModules/index.module.css';
import { Notification } from "./pages/notification";
import Errorpage from "./pages/error";
import Unauthorized from "./pages/unauthorized";
import Repeat from "./pages/repeat.mjs";
import DesignerDashboard from "./pages/designerDashboard.mjs";

function App() {

  const [visibleBlck, setVisibleBlack] = useState();
  const [pushLeft, setPushLeft] = useState();

  const [changeView, setChangeView] = useState();

  const [isLoggedIn, setLoggedin] = useState(
    localStorage.getItem('isLoggedIn') === 'true'
  );

  const [userName, setUserName] = useState(
    localStorage.getItem('uname')
  );

  const apiURL = process.env.REACT_APP_SELLER;
  let jToken = localStorage.getItem('token');
  // const navigate = useNavigate();  

  // const [hoverUserSegmentLI, sethoverUserSegmentLI] = useState(null);

  // This is used to set user name
  function uname(name) {
    setUserName(name);
    localStorage.setItem('uname', name);
  }

  // This is used to set the value true when userlogin
  function changeToLogin() {
    setLoggedin(true)
    localStorage.setItem('isLoggedIn', 'true');
  }

  // This is used to set the value false when userlogin
  async function changeToSignout() {
    try {
      const response = await fetch(`${apiURL}/api/sellerSignout`, {
        method: 'GET',
        headers: {
          'Content-type': 'Application/json',
          'Authorization': `Bearer ${jToken}`
        },
        credentials: "include"
      })

      if (response.status === 200) {
        setLoggedin(false);
        localStorage.setItem('isLoggedIn', 'false');
        localStorage.setItem('uname', '');
        localStorage.setItem('token', '');
        localStorage.setItem('ctoken', '');
      } else {
        throw new Error('Error while logging out!');
      }
    } catch (error) {
      console.log(error.message);
    }

  }

  const handelInnerWidth = () => {
    if (window.innerWidth < 1000) {
      setChangeView(true);
    } else {
      setChangeView(false);
    }
  }

  useEffect(() => {
    handelInnerWidth();

    return () => {
      window.removeEventListener('resize', handelInnerWidth);
    }
  }, [])

  useEffect(() => {
    window.addEventListener('resize', handelInnerWidth);

    return () => {
      window.removeEventListener('resize', handelInnerWidth);
    }
  }, [])

  function displayHeaderUL(e) {
    e.preventDefault();
    setPushLeft(true);
    setVisibleBlack(true);
  }

  function closeBlackScrn(e) {
    e.preventDefault();
    setPushLeft(false);
    setVisibleBlack(false);
  }

  return (
    <>
      <BrowserRouter>
        <div className={`${styles.sellerMasterDiv}`}>
          <div className={`${styles.sellerDIV}`}>
            <div>
              <div className={`${styles.humburgerBox}`} id='hamburgerB'
                onClick={(e) => displayHeaderUL(e)}>
                <div className={`${styles.humburgerDiv}`}></div>
                <div className={`${styles.humburgerDiv}`}></div>
                <div className={`${styles.humburgerDiv}`}></div>
              </div>
              <div className={`${styles.sellerLogoDiv}`}>
                <Link to='/' className={`${styles.sellerHeaderLogoAnchor}`}>
                  <img src={logo} alt='display' className={`${styles.sellerLogoIMG}`}>
                  </img>
                </Link>
              </div>
            </div>
            <div className={`${styles.blackDisplay}`} style={visibleBlck ? { visibility: 'visible' } : { visibility: 'hidden' }}
              onClick={e => closeBlackScrn(e)}>
              {/* <div className={`${styles.closeLeft}`}></div>
                        <div className={`${styles.closeRight}`}></div> */}
            </div>
            <ol className={!changeView ? `${style.sellerHeader}` : `${style.sellerHeaderChange}`}
              style={pushLeft ? { left: '0px' } : { left: '-190px' }}>
              {isLoggedIn ?
                (
                  <Link to='/' className={`${style.sellerHeaderAnchor}`}>
                    <span className={`${styles.sellerAnchorSpan}`}>
                      {userName.toUpperCase()}
                    </span>
                  </Link>
                ) :
                (
                  <Link to='/login' className={`${style.sellerHeaderAnchor}`}>
                    <span className={`${styles.sellerAnchorSpan}`}>
                      {'Login'.toUpperCase()}
                    </span>
                  </Link>
                )}

              <Link to='/dashboard' className={`${style.sellerHeaderAnchor}`}>
                <span className={`${styles.sellerAnchorSpan}`}>
                  {'Dashboard'.toUpperCase()}
                </span>
              </Link>


              <Link to='/upload' className={`${style.sellerHeaderAnchor}`}>
                <span className={`${styles.sellerAnchorSpan}`}>
                  {'upload'.toUpperCase()}
                </span>
              </Link>


              <Link to='/notification' className={`${style.sellerHeaderAnchor}`}>
                <span className={`${styles.sellerAnchorSpan}`}>
                  {'Notification'.toUpperCase()}
                </span>
              </Link>


              <Link to='/returns' className={`${style.sellerHeaderAnchor}`}>
                <span className={`${styles.sellerAnchorSpan}`}>
                  {'return'.toUpperCase()}
                </span>
              </Link>


              <Link to='/Orders' className={`${style.sellerHeaderAnchor}`}>
                <span className={`${styles.sellerAnchorSpan}`}>
                  {'Orders'.toUpperCase()}
                </span>
              </Link>


              <Link to='/ontransit' className={`${style.sellerHeaderAnchor}`}>
                <span className={`${styles.sellerAnchorSpan}`}>
                  {'Current'.toUpperCase()}
                </span>
              </Link>


              <Link to='/manage' className={`${style.sellerHeaderAnchor}`}>
                <span className={`${styles.sellerAnchorSpan}`}>
                  {'manage'.toUpperCase()}
                </span>
              </Link>

            </ol>
          </div>
          <Outlet />
          <div className={`${styles.sellerBody}`}>
            <Routes>
              <Route index element={<Information loginStatus={changeToSignout} />} />
              <Route path="/login" element={<SellerLogin loginStatus={changeToLogin} username={uname} />} />
              <Route path="/signup" element={<SellerSignup loginStatus={changeToLogin} username={uname} />} />
              <Route path="/dashboard" element={<Dashboard loginStatus={changeToSignout} />} />
              <Route path="/designerDashboard" element={<DesignerDashboard loginStatus={changeToSignout} />} />
              <Route path="/upload" element={<Upload loginStatus={changeToSignout} />} />
              <Route path="/returns" element={<ReturnDB loginStatus={changeToSignout} />} />
              <Route path="/Orders" element={<OrderRequest loginStatus={changeToSignout} />} />
              <Route path="/ontransit" element={<OnTransitDB loginStatus={changeToSignout} />} />
              <Route path="/manage" element={<ManageProd loginStatus={changeToSignout} />} />
              <Route path="/update/:prodType/:prodId" element={<Update loginStatus={changeToSignout} />} />
              <Route path="/notification" element={<Notification loginStatus={changeToSignout} />} />
              <Route path="/error" element={<Errorpage loginStatus={changeToSignout} />} />
              <Route path="/unauthorized" element={<Unauthorized />} />
              <Route path="/repeat/:prodType/:prodId" element={<Repeat loginStatus={changeToSignout} />} />
            </Routes>
          </div>
        </div>
      </BrowserRouter>
    </>
  );
}

export default App;
